import React from 'react';
import { useProductContext } from './product-context';
import PagingControlWrapper from '../PagingControlWrapper';

export const ProductPagingControlWrapper = () => {
  const { totalRecords } = useProductContext();
  return <PagingControlWrapper totalRecords={totalRecords} />;
};
